/** Fill ratio at or above which public surfaces reveal the "X/Y" count. */
export const CAPACITY_REVEAL_RATIO = 0.7;

/**
 * Public surfaces hide the count while a course or event still looks empty —
 * a low number puts people off signing up. Full always shows, so waitlist
 * state stays clear. Admin surfaces opt out and see exact numbers.
 */
export const shouldRevealCapacity = (
  enrolled: number | null | undefined,
  capacity: number | null | undefined,
): boolean => {
  if (capacity == null || !Number.isFinite(capacity) || capacity <= 0) return false;
  if (enrolled == null || !Number.isFinite(enrolled)) return false;
  return enrolled / capacity >= CAPACITY_REVEAL_RATIO;
};
